import { CreateUniqId } from "../../../Utility";
import Spinner from "../../../videos/Spinner.gif";

export const RenderLoadingSpinnerInImageTag = (width, height, msg) => {
  return (
    <>
      <div className={`flex flex-col  justify-center items-center`}>
        <img
          key={CreateUniqId("SpinnerGif-")}
          src={Spinner}
          alt="Spinner for representing lodging"
          loading="lazy"
          className={` ${width ? width : " w-10 "}  ${
            height ? height : " h-10 "
          } alt="Spinner" srcset="" loading="lazy`}
        />
        <h3 className={` text-Brand-Color font-bold tracking-wider`}>
          {msg ? msg : "Loading..."}
        </h3>
      </div>
    </>
  );
};

export const RenderLoadingSpinnerIcon = (fontSize) => {
  return (
    <>
      <i
        class={`ri-loader-fill ${
          fontSize ? fontSize : "font-medium"
        } text-Brand-Color`}
      ></i>
    </>
  );
};

export function getDeviceInfo() {
  const userAgent = window.navigator.userAgent;
  const platform = window.navigator.platform;
  const appName = window.navigator.appName;
  const appVersion = window.navigator.appVersion;

  return {
    userAgent,
    platform,
    appName,
    appVersion,
  };
}
